import { render } from "./projects-filter.vue?vue&type=template&id=227a70f1"
import script from "./projects-filter.vue?vue&type=script&lang=js"
export * from "./projects-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__